/** What an app connecting to Finnecto asks the signed-in person, for the company of this session. */
export interface ConnectorConsent {
  clientName: string
  clientHost: string
  society: { id: number, name: string }
  companies: { id: number, name: string }[]
  email: string
  eligible: boolean
}

export type ConnectorDecision = 'allow' | 'deny'

export type ConnectorConsentFailure = 'invalid_flow' | 'not_allowed' | 'unavailable'

export class ConnectorConsentError extends Error {
  constructor(public readonly failure: ConnectorConsentFailure) {
    super(failure)
  }
}

export interface ConnectorConsentRepository {
  get(flow: string): Promise<ConnectorConsent>
  /** Returns where the browser goes next: always the connector's own URL, set by the api. */
  decide(flow: string, decision: ConnectorDecision): Promise<string>
  /** Disconnects every app the signed-in person approved for this company. */
  disconnect(): Promise<void>
}
